import { apiRequest } from "../../services/apiService";
import {
  GET_COUNTRY_FAIL,
  GET_COUNTRY_REQUEST,
  GET_COUNTRY_SUCCESS,
  GET_REGION_FAIL,
  GET_REGION_REQUEST,
  GET_REGION_SUCCESS,
  GET_TIMEZONE_FAIL,
  GET_TIMEZONE_REQUEST,
  GET_TIMEZONE_SUCCESS,
} from "../constant";

export const countryAllList = (data) => {
  return async (dispatch) => {
    dispatch({ type: GET_COUNTRY_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/location/countryAllList`,
      data: data,
    });
    if (response) {

      if (response?.data?.data) {
        const rawData = response?.data?.data;
        dispatch({
          type: GET_COUNTRY_SUCCESS,
          payload: rawData.countries,
        });
      }
    } else if (error) {
      dispatch({ type: GET_COUNTRY_FAIL });
    }
  };
};
export const countryList = (data) => {
  return async (dispatch) => {
    dispatch({ type: GET_COUNTRY_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/location/countryList`,
      data: data,
    });
    if (response) {

      if (response?.data?.data) {
        const rawData = response?.data?.data;
        dispatch({
          type: GET_COUNTRY_SUCCESS,
          payload: rawData.countries,
        });
      }
    } else if (error) {
      dispatch({ type: GET_COUNTRY_FAIL });
    }
  };
};
export const regionList = () => {
  return async (dispatch) => {
    dispatch({ type: GET_REGION_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `/location/regionList`,
    });
    if (response) {
      if (response?.data?.data) {
        const rawData = response?.data?.data.regions;
        dispatch({
          type: GET_REGION_SUCCESS,
          payload: rawData,
        });
      }
    } else if (error) {
      dispatch({ type: GET_REGION_FAIL });
    }
  };
};
export const timezoneList = () => {
  return async (dispatch) => {
    dispatch({ type: GET_TIMEZONE_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/location/getTimezone`,
    });
    if (response) {
      if (response?.data?.data) {
        const rawData = response?.data?.data;
        dispatch({
          type: GET_TIMEZONE_SUCCESS,
          payload: rawData,
        });
      }
    } else if (error) {
      dispatch({ type: GET_TIMEZONE_FAIL });
    }
  };
};
